import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import {
  RouterProvider,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router';
import { Toaster } from '@/components/ui/use-toast';
import { FirebaseQueryProvider } from './backend/context';
import { useAuth } from './backend/context/auth-management';
import { router } from './routes';

import { PostHogProvider } from './components/providers/posthog-provider';

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });
}

const Main = Sentry.withProfiler(() => {
  const initialize = useAuth((s) => s.initialize);

  useEffect(() => {
    initialize();
  }, []);

  return (
    <PostHogProvider>
      <FirebaseQueryProvider>
        <RouterProvider router={router} />
        <Toaster position="top-center" />
      </FirebaseQueryProvider>
    </PostHogProvider>
  );
});

createRoot(document.getElementById('root')!).render(<Main />);
